import { createContext, useContext, useState, useEffect } from "react";
import { api, masterApi, tokenValid } from "@/lib/api";

const AuthContext = createContext(null);
const REFRESH_MS = 30 * 60 * 1000;
const load = (k) => { try { return JSON.parse(localStorage.getItem(k) || "null"); } catch { return null; } };
// Rehydrate only sessions whose token is still valid so refresh never lands on a broken screen.
const initUser = () => (tokenValid(localStorage.getItem("zc_store_token")) ? load("zc_user") : null);
const initMaster = () => {
  const t = localStorage.getItem("zc_master_token");
  return t === "member" || tokenValid(t) || tokenValid(localStorage.getItem("zc_store_token")) ? load("zc_account") : null;
};

export const AuthProvider = ({ children }) => {
  const [master, setMaster] = useState(initMaster);
  const [user, setUser] = useState(initUser);
  const [activeStaff, setActiveStaffState] = useState(() => (initUser() ? load("zc_staff") : null));

  useEffect(() => {
    if (!user && !master) return undefined;
    const refresh = () => {
      if (document.visibilityState === "hidden") return;
      if (localStorage.getItem("zc_store_token")) api.post("/auth/refresh").then((r) => { if (localStorage.getItem("zc_store_token")) localStorage.setItem("zc_store_token", r.data.token); }).catch(() => {});
      const mt = localStorage.getItem("zc_master_token");
      if (tokenValid(mt)) masterApi.post("/auth/refresh-master").then((r) => { if (localStorage.getItem("zc_master_token")) localStorage.setItem("zc_master_token", r.data.token); }).catch(() => {});
    };
    refresh();
    const t = setInterval(refresh, REFRESH_MS);
    document.addEventListener("visibilitychange", refresh);
    return () => { clearInterval(t); document.removeEventListener("visibilitychange", refresh); };
  }, [user, master]);

  const loginMaster = (token, account) => {
    localStorage.setItem("zc_master_token", token);
    localStorage.setItem("zc_account", JSON.stringify(account));
    sessionStorage.removeItem("zb_logged_out");
    setMaster(account);
  };
  const updateMaster = (patch) => {
    const next = { ...master, ...patch };
    localStorage.setItem("zc_account", JSON.stringify(next));
    setMaster(next);
  };
  const enterPin = (token, u) => {
    localStorage.setItem("zc_store_token", token);
    localStorage.setItem("zc_user", JSON.stringify(u));
    setUser(u);
  };
  const setActiveStaff = (staff) => {
    if (staff) localStorage.setItem("zc_staff", JSON.stringify(staff));
    else localStorage.removeItem("zc_staff");
    setActiveStaffState(staff);
  };
  const exitPin = () => {
    localStorage.removeItem("zc_staff");
    setActiveStaffState(null);
  };
  const logout = () => {
    // Clear every stored login artefact (tokens, staff, passkey device/prompt flags, deep links).
    Object.keys(localStorage).filter((k) => ["zc_master_token", "zc_account", "zc_store_token", "zc_user", "zc_staff"].includes(k) || k.startsWith("zb_passkey") || k === "zb_return_to")
      .forEach((k) => localStorage.removeItem(k));
    sessionStorage.clear();
    sessionStorage.setItem("zb_logged_out", "1");
    setMaster(null); setUser(null); setActiveStaffState(null);
  };

  return (
    <AuthContext.Provider value={{ master, user, activeStaff, loginMaster, updateMaster, enterPin, setActiveStaff, exitPin, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
